import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslations } from "next-intl";
import { Heading, PageShell, Text } from "@/components/ui";
import { readApiError } from "@/lib/api-error";
import { completeOAuthSession, fetchLoginRedirect } from "@/services/api/auth";
import { useAuthStore } from "@/stores/authStore";

export function PostLoginPage() {
  const navigate = useNavigate();
  const t = useTranslations("auth");
  const setSession = useAuthStore((s) => s.setSession);
  // S3 V-4: Google sign-in is refused while emailed codes are on — say so, not "it failed".
  const [failed, setFailed] = useState<"generic" | "google_unavailable" | null>(null);

  useEffect(() => {
    async function redirectAfterLogin() {
      try {
        const session = await completeOAuthSession();
        setSession(session.accessToken, session.user);
        const { redirectTo } = await fetchLoginRedirect();
        navigate(redirectTo, { replace: true });
      } catch (err) {
        setFailed(
          readApiError(err)?.code === "GOOGLE_SIGNIN_UNAVAILABLE"
            ? "google_unavailable"
            : "generic",
        );
      }
    }

    void redirectAfterLogin();
  }, [navigate, setSession]);

  return (
    <PageShell width="form" data-testid="post-login-page">
      <Heading as="h1" level="page">
        {t("signingYouIn")}
      </Heading>
      {failed && (
        <Text role="alert" className="mt-4 text-[var(--danger)]" data-testid="post-login-error">
          {failed === "google_unavailable"
            ? t("errors.GOOGLE_SIGNIN_UNAVAILABLE")
            : t("postLoginError")}
        </Text>
      )}
    </PageShell>
  );
}
